import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";
import { defaultColDef } from "@/setup/ag-grid/mesf-theme";

export const ProbesTable = () => {
  const {
    state: { probes, casProcessData },
  } = useHeatReportContext();

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <div
          style={{ height: "20rem" }}
          key={`${probes.length}-${casProcessData.ProcessId}`}
        >
          <AgGridReact
            rowData={probes}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            domLayout="normal"
            getRowId={(params) => params.data.ProbeId}
          />
        </div>
      </Box>
    </BorderedTablePaper>
  );
};
